export default function Qualifying() {
  const groups = [
    { name: 'Grupo Amarelo', color: 'bg-yellow-500', icon: 'ri-flag-line' },
    { name: 'Grupo Verde', color: 'bg-green-500', icon: 'ri-flag-line' }
  ];

  const schedule = [
    {
      date: '11/02/2026',
      day: 'Quarta-feira',
      events: [
        { time: '20h', group: 'Grupo Amarelo', color: 'bg-yellow-500' },
        { time: '21h', group: 'Grupo Verde', color: 'bg-green-500' }
      ]
    },
    {
      date: '18/02/2026',
      day: 'Quarta-feira',
      events: [
        { time: '21h', group: 'Repescagem', color: 'bg-orange-500' }
      ]
    }
  ];

  const points = [
    { position: '1º', points: 15 },
    { position: '2º', points: 12 },
    { position: '3º', points: 10 },
    { position: '4º', points: 8 },
    { position: '5º', points: 7 },
    { position: '6º', points: 6 },
    { position: '7º', points: 5 },
    { position: '8º', points: 4 },
    { position: '9º', points: 3 },
    { position: '10º', points: 2 },
    { position: 'Demais', points: 1 }
  ];

  return (
    <section id="seletiva" className="py-16 sm:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 sm:mb-6">
            Seletiva Oficial — Série A e B
          </h2>
          <p className="text-base sm:text-lg text-gray-600 max-w-4xl mx-auto leading-relaxed">
            A seletiva classificatória separa os pilotos entre Série A e Série B, garantindo competitividade equilibrada em ambas as divisões.
          </p>
        </div>

        {/* Local */}
        <div className="bg-gray-900 text-white p-8 rounded-xl mb-12 text-center">
          <div className="flex items-center justify-center mb-4">
            <div className="w-12 h-12 flex items-center justify-center bg-orange-500 rounded-lg mr-4">
              <i className="ri-map-pin-line text-2xl text-white"></i>
            </div>
            <h3 className="text-2xl font-bold">Local da Seletiva</h3>
          </div>
          <p className="text-3xl font-bold text-orange-500">Autódromo de Curitiba</p>
        </div>

        {/* Grupos */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-12">
          {groups.map((group, index) => (
            <div key={index} className="bg-gray-50 p-8 rounded-xl border-2 border-gray-200 text-center">
              <div className={`w-16 h-16 flex items-center justify-center ${group.color} rounded-full mx-auto mb-4`}>
                <i className={`${group.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900">{group.name}</h3>
              <p className="text-gray-600 mt-2">Divisão aleatória</p>
            </div>
          ))}
        </div>

        {/* Datas e Horários */}
        <div className="mb-12">
          <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center">Datas e Horários (Horário de Brasília)</h3>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            {schedule.map((day, index) => (
              <div key={index} className="bg-gray-50 p-8 rounded-xl border-2 border-gray-200">
                <div className="mb-6">
                  <p className="text-2xl font-bold text-gray-900">{day.date}</p>
                  <p className="text-base text-gray-600">{day.day}</p>
                </div>
                <div className="space-y-3">
                  {day.events.map((event, idx) => (
                    <div key={idx} className="flex items-center justify-between bg-white p-4 rounded-lg">
                      <span className="text-lg font-semibold text-gray-900">{event.time}</span>
                      <span className={`px-4 py-2 ${event.color} text-white rounded-lg font-semibold`}>
                        {event.group}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Formato da Seletiva */}
        <div className="bg-orange-500/10 border-l-4 border-orange-500 p-8 rounded-lg mb-12">
          <h3 className="text-2xl font-bold text-gray-900 mb-6">Formato da Seletiva (para cada grupo)</h3>
          <p className="text-base text-gray-700 mb-6">
            Cada grupo disputará duas baterias, cada uma com seu próprio qualifying:
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            <div className="bg-white p-6 rounded-lg">
              <h4 className="text-xl font-bold text-gray-900 mb-3">Bateria 1</h4>
              <ul className="space-y-2 text-gray-700">
                <li className="flex items-center">
                  <i className="ri-time-line text-orange-500 mr-2"></i>
                  Qualifying 1: 10 minutos
                </li>
                <li className="flex items-center">
                  <i className="ri-flag-line text-orange-500 mr-2"></i>
                  Corrida 1: 20 minutos
                </li>
              </ul>
            </div>
            <div className="bg-white p-6 rounded-lg">
              <h4 className="text-xl font-bold text-gray-900 mb-3">Bateria 2</h4>
              <ul className="space-y-2 text-gray-700">
                <li className="flex items-center">
                  <i className="ri-time-line text-orange-500 mr-2"></i>
                  Qualifying 2: 10 minutos
                </li>
                <li className="flex items-center">
                  <i className="ri-flag-line text-orange-500 mr-2"></i>
                  Corrida 2: 20 minutos
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Sistema de Pontuação */}
        <div className="mb-12">
          <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center">Sistema de Pontuação da Seletiva</h3>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
            {points.map((item, index) => (
              <div key={index} className="bg-gray-900 text-white p-6 rounded-xl text-center">
                <p className="text-2xl font-bold text-orange-500 mb-2">{item.position}</p>
                <p className="text-xl font-semibold">{item.points} {item.points === 1 ? 'ponto' : 'pontos'}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Classificação */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          <div className="bg-gray-900 text-white p-8 rounded-xl">
            <div className="flex items-center mb-6">
              <div className="w-12 h-12 flex items-center justify-center bg-orange-500 rounded-lg mr-4">
                <i className="ri-vip-crown-line text-2xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold">Classificação Direta — Série A</h3>
            </div>
            <p className="text-lg text-gray-300 leading-relaxed">
              <strong className="text-orange-500">Top 10</strong> do Grupo Amarelo + <strong className="text-orange-500">Top 10</strong> do Grupo Verde
            </p>
            <p className="text-base text-gray-400 mt-4">Total: 20 pilotos classificados</p>
          </div>

          <div className="bg-gray-900 text-white p-8 rounded-xl">
            <div className="flex items-center mb-6">
              <div className="w-12 h-12 flex items-center justify-center bg-orange-500 rounded-lg mr-4">
                <i className="ri-restart-line text-2xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold">Repescagem</h3>
            </div>
            <ul className="space-y-3 text-gray-300">
              <li className="flex items-start">
                <i className="ri-checkbox-circle-line text-orange-500 mr-2 mt-1"></i>
                <span>Qualifying único: 10 minutos</span>
              </li>
              <li className="flex items-start">
                <i className="ri-checkbox-circle-line text-orange-500 mr-2 mt-1"></i>
                <span>Corrida: 20 minutos</span>
              </li>
              <li className="flex items-start">
                <i className="ri-checkbox-circle-line text-orange-500 mr-2 mt-1"></i>
                <span><strong className="text-orange-500">5 primeiros</strong> entram na Série A</span>
              </li>
              <li className="flex items-start">
                <i className="ri-checkbox-circle-line text-orange-500 mr-2 mt-1"></i>
                <span>Demais formam a Série B</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
